import { AbstractControl } from '@angular/forms';
import { SpecialHandling } from '@features/forms/form-renderer-components/standard-form-components/form-special-handling/form-special-handling.component';

export function SpecialHandlingValidator (
  requireReason: boolean,
  requireFileUpload: boolean
) {
  return (group: AbstractControl) => {
    const value = group.value as SpecialHandling;
    const handlingOn = !!(
      value && (
        value.name ||
        value.address1 ||
        value.address2 ||
        value.city ||
        value.state ||
        value.country ||
        value.postalCode
      )
    );
    if (handlingOn) {
      const address1 = value.address1;
      const city = value.city;
      const state = value.state;
      const country = value.country;
      const postalCode = value.postalCode;
      const reason = value.reason;
      const fileUrl = value.fileUrl;
      const returnVal = {} as any;
      if (!address1) {
        returnVal.address1 = {
          i18nKey: 'common:textAddress1IsRequired',
          defaultValue: 'Address 1 is required'
        };
      }
      if (!city) {
        returnVal.city = {
          i18nKey: 'common:textCityIsRequired',
          defaultValue: 'City is required'
        };
      }
      if (!state) {
        returnVal.state = {
          i18nKey: 'common:textStateIsRequired',
          defaultValue: 'State is required'
        };
      }
      if (!country) {
        returnVal.country = {
          i18nKey: 'common:textCountryIsRequired',
          defaultValue: 'Country is required'
        };
      }
      if (!postalCode) {
        returnVal.postalCode = {
          i18nKey: 'common:textPostalCodeIsRequired',
          defaultValue: 'Postal code is required'
        };
      }
      if (!reason && requireReason) {
        returnVal.reason = {
          i18nKey: 'common:textReasonIsRequired',
          defaultValue: 'Reason is required'
        };
      }
      if (!fileUrl && requireFileUpload) {
        returnVal.file = {
          i18nKey: 'common:textFileIsRequired',
          defaultValue: 'File is required'
        };
      }
      const hasErrors = Object.keys(returnVal).length > 0;

      return hasErrors ? returnVal : null;
    } else {
      return null;
    }
  };

};
